import ErrorMessage from '../components/report-error';

const NotFound = () => <ErrorMessage />;
export default NotFound;
